<main id="home-v2">
  <div
    @fade-on-if
    *ngIf="showSplash"
  >
    <app-landing-splash-v2></app-landing-splash-v2>
  </div>
  <div
    @fade-on-if
    *ngIf="!showSplash"
  >
    <app-nav-bar-v2></app-nav-bar-v2>
    <app-landing-v2></app-landing-v2>
    <app-footer-v2></app-footer-v2>
  </div>
</main>
